import { PROCESS_TIME_BUCKETS, PROCESS_TIME_DEFAULT_SUGGESTION, PROCESS_TIME_OPTION, AUTOMATION_SOURCE } from 'utils/constants';

export function getProcessTimeBucket(elapsedSeconds) {
    if (elapsedSeconds == null || Number.isNaN(elapsedSeconds) || elapsedSeconds < 0) {
        return PROCESS_TIME_DEFAULT_SUGGESTION;
    }
    const bucket = PROCESS_TIME_BUCKETS.find(({ maxSeconds }) => elapsedSeconds <= maxSeconds);
    return bucket ? bucket.value : PROCESS_TIME_DEFAULT_SUGGESTION;
}

export function getElapsedSeconds(agentTime, now = Date.now()) {
    if (!agentTime) return 0;
    const start = new Date(agentTime).getTime();
    if (Number.isNaN(start)) return 0;
    return Math.max(0, Math.floor((now - start) / 1000));
}

export function computeProcessTimeSuggestion({ agentTime, now = Date.now(), driverValue }) {
    if (driverValue === PROCESS_TIME_OPTION.SLASH) {
        return PROCESS_TIME_OPTION.SLASH;
    }
    return getProcessTimeBucket(getElapsedSeconds(agentTime, now));
}

export function driverResolvesToSlash({ driverValue, driverSuggestionValue }) {
    if (driverValue === PROCESS_TIME_OPTION.SLASH) return true;
    const hasRealDriverValue = driverValue != null && driverValue !== '';
    if (hasRealDriverValue) return false;
    const hasRealSuggestion = driverSuggestionValue != null && driverSuggestionValue !== '' && driverSuggestionValue !== PROCESS_TIME_OPTION.SLASH;
    return !hasRealSuggestion;
}

export function shouldSlashOverrideProcessTime({
    hasField,
    processTimeValue,
    processTimeSource,
    processTimeUserEdited,
    driverValue,
    driverSuggestionValue,
}) {
    if (!hasField) return false;
    const isEmpty = !processTimeValue && processTimeValue !== false && processTimeValue !== 0;
    if (isEmpty) return false;
    const isAutoSourced = processTimeSource === AUTOMATION_SOURCE.AUTO && !processTimeUserEdited;
    if (!isAutoSourced) return false;
    return driverResolvesToSlash({ driverValue, driverSuggestionValue });
}

// Returns `label` unchanged when the lookup has no match, which is safe: `processTime` is in the
// backend's VALUE_CONFIG_EXCLUDED (BEAST-11651 design section 8.4), so its option list is never
// location-configured and the lookup is always the ProcessTime enum the buckets were written against.
// The label alone stays configurable, which does not affect this mapping. That exclusion exists
// precisely because this function originates values rather than displaying them - if `processTime`
// is ever made value-configurable, a location's own options could not be honoured here and off-list
// values would be written with nothing validating them on save (design section 7.2).
export function resolveProcessTimeFieldValue(label, lookup) {
    if (!lookup || !lookup.displayExpr || !lookup.valueExpr || !Array.isArray(lookup.dataSource)) {
        return label;
    }
    const match = lookup.dataSource.find((option) => option?.[lookup.displayExpr] === label);
    return match ? match[lookup.valueExpr] : label;
}
